import { render, staticRenderFns } from "./WhyYouCanPedalsure.vue?vue&type=template&id=42c4ec5c&scoped=true"
import script from "./WhyYouCanPedalsure.vue?vue&type=script&lang=js"
export * from "./WhyYouCanPedalsure.vue?vue&type=script&lang=js"
import style0 from "./WhyYouCanPedalsure.vue?vue&type=style&index=0&id=42c4ec5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c4ec5c",
  null
  
)

export default component.exports